module.exports = (__webpack_require__(4))(1726);


//////////////////
// WEBPACK FOOTER
// delegated ./node_modules/history/createTransitionManager.js from dll-reference vendorProd_library
// module id = 1396
// module chunks = 42